import { render, staticRenderFns } from "./coApplicantModal.vue?vue&type=template&id=324a0347&"
import script from "./coApplicantModal.vue?vue&type=script&lang=js&"
export * from "./coApplicantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports